export default () => ({
  $schema: 'https://microsoft.github.io/AdaptiveCards/schemas/adaptive-card.json',
  type: 'AdaptiveCard',
  body: [
    {
      type: 'TextBlock',
      text: 'This is the first line'
    },
    {
      type: 'TextBlock',
      text: 'This is the second line'
    }
  ]
});
